import * as Icons from "lucide-react";

// Renders a lucide-react icon by name with a safe fallback.
export default function Icon({ name, className, strokeWidth = 1.75, ...props }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} strokeWidth={strokeWidth} {...props} />;
}
